import { getParam } from "../util/tools";

const Tabs = () => {
  /**
   * Lazy load our map iframe
   * This helps with preventing any render blocking
   */
  const loadMap = iframe => {
    const src = iframe.getAttribute("data-src");
    iframe.setAttribute("src", src);
  };

  const onTabClick = (item, tabContainer) => {
    const activeStates = [].slice.call(
      tabContainer.getElementsByClassName("active")
    );

    activeStates.forEach(active => {
      active.classList.remove("active");
    });

    item.classList.add("active");

    const selector = item.children[0].href.split("#")[1];
    const tabContent = document.getElementById(selector);
    tabContent.classList.add("active");

    if (item.classList.contains("tab--map")) {
      const iframe = tabContent.querySelector("iframe");
      loadMap(iframe);
    }
  };

  const initTabs = tabContainer => {
    const tabs = tabContainer.getElementsByClassName("tab");

    for (let i = 0; i < tabs.length; i += 1) {
      tabs[i].addEventListener("click", e => {
        e.preventDefault(); // stop ID hash being added to URL and jumping to div
        if (e.currentTarget.classList.contains("active")) {
          return;
        }

        onTabClick(e.currentTarget, tabContainer);
      });
    }

    // Check if we have passed the map param
    // and set this as active
    if (getParam("tab") === "map") {
      const mapTab = tabContainer.querySelector(".tab--map");
      onTabClick(mapTab, tabContainer);
    }
  };

  const init = () => {
    // get all the tabContainer in DOM
    const tabsContainer = [].slice.call(
      document.getElementsByClassName("tabset")
    );

    if (getParam("tab") === "map") {
      setTimeout(() => {
        const tabs = document.querySelectorAll(".tabs");

        for (let i = 0; i < tabs.length; i += 1) {
          const tab = tabs[i];
          tab.scrollLeft = tab.scrollWidth;
        }
      }, 500);
    }

    // init them
    tabsContainer.forEach(tabContainer => {
      initTabs(tabContainer);
    });
  };

  return {
    init
  };
};

export default Tabs;
